import styled from "styled-components/macro"

const Text = styled.div`
  p:not(:last-child) {
    margin-bottom: ${(p) => p.theme.baseLineHeight}em;
  }
`

export { Text }
